import styled from 'styled-components';

export const Container = styled.div`
  height: 444px;
  display: flex;
`;
export const BarIndicator = styled.div`
  height: 100%;
  width: 3px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
`;
export const LayerCaption = styled.div`
  p{
    margin: 0 2%;
    width: 16px;
    height: 17px;
    text-align: left;
    font: normal normal normal 12px/20px Poppins !important;
    letter-spacing: 0px;
    color: black;
    opacity: 1;
  }
  display: flex;
  margin-left: -6px;
  margin-top: 20%;
`
export const BarChartContainer = styled.div`
  height: 100%;
  width: 34px;
  max-width: 34px; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  span{
    width: 12px;
    height: 12px;
    text-align: center;
    font: normal normal normal 12px/18px Poppins;
    letter-spacing: 0px;
    color: #161615;
    opacity: 1;
  }

`
